module.exports = __webpack_public_path__ + "static/media/completed.6afd2373.png";